var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.403 22.9303C22.6959 23.2232 23.1707 23.2232 23.4636 22.9303C23.7565 22.6374 23.7565 22.1625 23.4636 21.8696L17.594 16L23.4636 10.1303C23.7565 9.83741 23.7565 9.36254 23.4636 9.06965C23.1707 8.77675 22.6959 8.77675 22.403 9.06965L16.5333 14.9393L10.6636 9.06965C10.3707 8.77675 9.89586 8.77675 9.60297 9.06965C9.31008 9.36254 9.31008 9.83741 9.60297 10.1303L15.4726 16L9.60297 21.8696C9.31008 22.1625 9.31008 22.6374 9.60297 22.9303C9.89587 23.2232 10.3707 23.2232 10.6636 22.9303L16.5333 17.0606L22.403 22.9303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseModal);
export default __webpack_public_path__ + "static/media/ico-close-modal.915acd7aeccb85f028155c802add447c.svg";
export { ForwardRef as ReactComponent };